/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */

/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import axiosMain from "../../http/axios/axios_main";
import TableComponent from "./Table";
import AuctionData from "../../constants/Datas";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTimer } from "react-timer-hook";
import {
  fetchAuctionCenterData,
  fetchAuctionCenterHeaderData,
  fetchAuctionCenterDataApiCall,
  fetchAuctionCenterDataSuccess,
  bidderConfirm,
  bidderIn,
  bidderOut,
  catelogFetchAllData,
  catelogSubmitData,
  catelogFetchAllDataSuccess,
  getSummaryOfTeaSoldData,
  getAuctioneerMarketSummaryData,
  getAuctioneerMarketSummaryWiseData,
  getAuctioneerMarketSummaryWiseDataSuccess,
  getMarketSummaryData,
  getMyPlannerData,
  callFetchAuctionCenterDataAPI,
  getMyCatalogData,
  removeFromMyCatalogAuctionBid,
  addToMyCatalogAuctionBid,
  getAndSetUserWiseDefaultColumnConfig,
  getAndSetUserWiseDefaultColumnConfigSuccess,
  myPlannerExportDataAPIResponse,
  backendNotificationAvailable,
  getBackendNotification,
} from "../../store/actions";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import "../../assets/css/auctionPage.css";
import { Table } from "react-bootstrap";
import CustomToast from "../../components/Toast";
import AuctionTable from "./AuctionTable";
import { ThreeDots } from "react-loader-spinner";
import ViewBidBookModal from "../auctionSearchBidBook/AuctionSearchBidBook";
import Modals from "../../components/common/Modal";
import Base64ToExcelDownload from "../Base64ToExcelDownload";
import { uploadedFileDownload } from "../uploadDocument/UploadedFileDownload";
import SummaryOfTeaSoldDataTable from "./SummaryOfTeaSoldTable";

let socket = false;
let isSummaryCalled = false;
let isPlannerCalled = false;
let isHoldAuctionCalled = false;
let activeTab = 1;
let generalType = 0;
let isCountForShow = false;
let countForShow = 0;
let sessionDelayNotificationCount = 0;
let auctionUserId =
  window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[3]
    ? atob(
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[3]
    )
    : "";

let auctionDetailId =
  window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[2]
    ? atob(
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[2]
    )
    : "";

let auctionCenterId =
  window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[4]
    ? atob(
      window.location.pathname &&
      window.location.pathname.split("/") &&
      window.location.pathname.split("/")[4]
    )
    : "";

let userCurrentStatus = atob(localStorage.getItem("argument13"));

let auctionData;
let auctionDataColumnDetails;
let auctionDataLiveBidDetails;

let allAuctionData;
let allAuctionDataColumnDetails;
let allAuctionDataLiveBidDetails;

let selectedDataForMyCatalog = [];
let intervalId;

let userRoleCode = atob(sessionStorage.getItem("argument6"));

let auctioneerWiseMarketSummary = null;
const Auction = () => {
  const dispatch = useDispatch();

  const activeClass = useSelector((state) => state.toggle.activeClass);

  const [leftNo, setLeftNo] = useState(0);
  const [rightNo, setRightNo] = useState(0);
  const [stickyInput, setStickyInput] = useState({
    leftNo: 0,
    rightNo: 0,
  });
  const [dataMenu, setdataMenu] = useState(false);

  const [
    showAuctioneerMarketWiseSummaryData,
    setShowAuctioneerMarketWiseSummaryData,
  ] = useState(false);
  const [
    auctioneerMarketWiseSummaryDataValue,
    setAuctioneerMarketWiseSummaryDataValue,
  ] = useState(false);

  const [stompClientForDisconnect, setStompClientForDisconnect] =
    useState(null);

  const [loader, setLoader] = useState(false);

  const [isShownBidBook, setIsShownBidBook] = useState(false);

  const [
    fetchAuctionCenterHeaderDataResponse,
    setFetchAuctionCenterHeaderDataResponse,
  ] = useState(null);

  const [isAuctionEnded, setIsAuctionEnded] = useState(false);
  const [backendNotification, setBackendNotification] = useState("");

  const [notifications, setNotifications] = useState([]);
  const [activeNotifications, setActiveNotifications] = useState([]);

  const handleTabClick = (tabNumber) => {
    activeTab = tabNumber;
    selectedDataForMyCatalog = [];

    console.log("tabNumber", tabNumber);

    if (1 == tabNumber || 4 == tabNumber || 5 == tabNumber || 6 == tabNumber) {
      localStorage.removeItem("maxBids");
      setLoader(true);
      let type =
        5 == tabNumber ? 2 : 6 == tabNumber ? 3 : 4 == tabNumber ? 4 : 1;
      viewuserwiseliveauctionApiCall(type, 0);
    }

    if (2 == tabNumber) {
      let type =
        5 == tabNumber ? 2 : 6 == tabNumber ? 3 : 4 == tabNumber ? 4 : 1;
      viewuserwiseliveauctionApiCall(type, 0);
      handleSummaryOfTeaSoldModal(true);
    }

    if (3 == tabNumber) {
      let type =
        5 == tabNumber ? 2 : 6 == tabNumber ? 3 : 4 == tabNumber ? 4 : 1;
      viewuserwiseliveauctionApiCall(type, 0);
      handlePlannerModal(true);
    }

    // if (4 == tabNumber) {
    //   let payloadData = {
    //     bidderId:auctionUserId,
    //     auctionDetailId:auctionDetailId,
    //   };
    //   dispatch(getMyCatalogData(payloadData));
    // }
  };

  const getMyCatalogDataResponse = useSelector(
    (state) => state.auctionPage?.getMyCatalogData?.responseData
  );

  // On auction marquee //
  const userRoleCode = atob(localStorage.getItem("argument6"));

  const auctionCenterIdFromURI = window.location.pathname?.split("/")[4]
    ? atob(window.location.pathname.split("/")[4])
    : "";

  const auctionTypeFromURL = window.location.pathname?.split("/")[1]

  const userIdForAuctionPage = auctionTypeFromURL === "auctionPage"
    ? atob(localStorage.getItem("argument2"))
    : window.location.pathname?.split("/")[3]
      ? atob(window.location.pathname.split("/")[3])
      : "";

  const getAuctionMarquee = async (roleCode) => {
    const validRoles = ['BUYER', 'SELLER', 'AUCTIONEER'];
    if (!validRoles.includes(roleCode)) {
      console.warn(`Role ${roleCode} is not allowed to fetch marquee data.`);
      return [];
    }

    try {
      const response = await axiosMain.post(
        `admin/marquee/getAuctionMarquee/roleCode/${roleCode}`,
        {
          auctionCenterId: auctionCenterIdFromURI,
          ...(roleCode === 'BUYER'
            ? { buyerId: userIdForAuctionPage }
            : roleCode === 'SELLER'
              ? { sellerId: userIdForAuctionPage }
              : roleCode === 'AUCTIONEER'
                ? { auctioneerId: userIdForAuctionPage }
                : {})
        }
      );

      const data = response.data;
      console.log("data...", data)

      if (data && Array.isArray(data)) {
        console.log("data...inside if", data)
        return data;
      } else {
        console.error("No data received:");
        return [];
      }

    } catch (error) {
      console.error(`Error fetching marquee data:`, error);
      return [];
    }
  };

  useEffect(() => {
    let timer;

    const fetchAndMonitor = async () => {
      if (!['BUYER', 'SELLER', 'AUCTIONEER'].includes(userRoleCode)) return;

      const data = await getAuctionMarquee(userRoleCode);
      setNotifications(data);

      const updateActive = () => {
        const now = new Date();
        const filtered = data.filter((n) => {
          const start = new Date(n.startDate);
          const end = new Date(n.endDate);
          return start <= now && now <= end;
        });
        setActiveNotifications(filtered);
      };

      updateActive();
      timer = setInterval(updateActive, 1000);
    };

    fetchAndMonitor();

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    localStorage.removeItem("maxBids");
    viewuserwiseliveauctionApiCall(1, 0);
    socket = true;
  }, []);

  const callFetchAuctionCenterDataAPIResponse = useSelector(
    (state) => state.auctionPage?.callFetchAuctionCenterDataApi
  );

  useEffect(() => {
    if (true == callFetchAuctionCenterDataAPIResponse) {
      dispatch(callFetchAuctionCenterDataAPI(false));
      selectedDataForMyCatalog = [];
      // if (4 == activeTab) {
      viewuserwiseliveauctionApiCall(
        5 == activeTab ? 2 : 6 == activeTab ? 3 : 4 == activeTab ? 4 : 1,
        0
      );
      // }
    }
  });

  const [
    fetchAuctionCenterDataApiCallResponse,
    setfetchAuctionCenterDataApiCallResponse,
  ] = useState(false);

  const [
    allFetchAuctionCenterDataApiCallResponse,
    setAllFetchAuctionCenterDataApiCallResponse,
  ] = useState(false);

  const viewuserwiseliveauctionApiCall = async (type, isExport) => {
    const baseURL =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_END_POINT_URL_DEV
        : process.env.REACT_APP_END_POINT_URL_PROD;
    const url = `/auctionbid/viewuserwiseliveauction`;
    if (
      0 != auctionDetailId &&
      null != auctionDetailId &&
      "null" != auctionDetailId &&
      0 != auctionUserId &&
      null != auctionUserId &&
      "null" != auctionUserId
    ) {
      let data = {
        auctionDetailId: auctionDetailId,
        userLoginId: auctionUserId,
        type: type,
        isExport: isExport,
      };

      axiosMain.post(url, data).then((res) => {
        if (200 == res?.data?.statusCode) {
          if (0 == isExport) {
            if (2 == type || 3 == type) {
              allAuctionData = res?.data;
              allAuctionDataColumnDetails =
                allAuctionData?.responseData?.columnDetails;
              allAuctionDataLiveBidDetails =
                allAuctionData?.responseData?.liveBidDetails;
              setAllFetchAuctionCenterDataApiCallResponse(true);
              setLoader(false);

              if (auctionDataLiveBidDetails == null) {
                clearInterval(intervalId);
              }
            } else {
              auctionData = res?.data;
              auctionDataColumnDetails =
                auctionData?.responseData?.columnDetails;
              auctionDataLiveBidDetails =
                auctionData?.responseData?.liveBidDetails;
              setfetchAuctionCenterDataApiCallResponse(true);
              setLoader(false);

              if (auctionDataLiveBidDetails == null) {
                clearInterval(intervalId);
              }
            }
          } else {
            let exportFileData = res?.data?.responseData?.exported_file;
            let fileName =
              1 == type
                ? "AuctionCatalogData.xlsx"
                : 2 == type
                  ? "PendingData.xlsx"
                  : 3 == type
                    ? "SoldUnsoldData.xlsx"
                    : 4 == type
                      ? "MyCatalog.xlsx"
                      : "AuctionData.xlsx";
            if (exportFileData != null) {
              Base64ToExcelDownload(exportFileData, fileName);
            }
            setLoader(false);
          }
        } else {
          if (2 == type || 3 == type) {
            setAllFetchAuctionCenterDataApiCallResponse(false);
            setLoader(false);
          } else {
            setfetchAuctionCenterDataApiCallResponse(false);
            setLoader(false);
          }
        }
      });
    }
  };

  useEffect(() => {
    if (true == fetchAuctionCenterDataApiCallResponse) {
      setfetchAuctionCenterDataApiCallResponse(false);
    }
  });

  useEffect(() => {
    if (true == allFetchAuctionCenterDataApiCallResponse) {
      setAllFetchAuctionCenterDataApiCallResponse(false);
    }
  });

  const getAndSetUserWiseDefaultColumnConfigResponse = useSelector(
    (state) =>
      state.auctionPage &&
      state.auctionPage.getAndSetUserWiseDefaultColumnConfigSuccess
  );

  useEffect(() => {
    if (true == getAndSetUserWiseDefaultColumnConfigResponse) {
      dispatch(getAndSetUserWiseDefaultColumnConfigSuccess(false));
      setShow(false);
      setLeftNo(0);
      setRightNo(0);
      setStickyInput({
        leftNo: 0,
        rightNo: 0,
      });

      setLoader(true);
      let type =
        5 == activeTab ? 2 : 6 == activeTab ? 3 : 4 == activeTab ? 4 : 1;
      viewuserwiseliveauctionApiCall(type, 0);
    }
  });

  const getDashboardDetailsForLiveAndWarmUpStatus = async (
    auctionDetailIdFromBody,
    sessionDetailIdFromBody
  ) => {
    if (
      undefined == auctionUserId ||
      null == auctionUserId ||
      0 == auctionUserId ||
      "" == auctionUserId
    ) {
      const urlForApiCall = `/auctionbid/getDashboardDetailsForLiveAndWarmUpStatus/${atob(
        sessionStorage.getItem("argument2")
      )}/${auctionCenterId}/${sessionDetailIdFromBody}`;

      await axiosMain.get(urlForApiCall, {}).then((res) => {
        if (200 == res?.data?.statusCode) {
          auctionUserId = res?.data?.responseData?.auctionUserLoginId;
        }
      });
    }

    let url =
      "/auctionPage/" +
      btoa(auctionDetailIdFromBody) +
      "/" +
      btoa(auctionUserId) +
      "/" +
      btoa(auctionCenterId) +
      "/" +
      window.location.pathname.split("/")[5];

    if (
      undefined != auctionUserId &&
      null != auctionUserId &&
      0 != auctionUserId &&
      "" != auctionUserId &&
      undefined != auctionCenterId &&
      null != auctionCenterId &&
      0 != auctionCenterId &&
      "" != auctionCenterId
    ) {
      const userConfirmed = window.confirm(
        "Your new sassion has stared. Do you want to redirect? \n\n Note : If you select cancel you need to go back to dashboard and select auction center for live auction session."
      );

      if (userConfirmed) {
        // Redirect to the new URL
        window.location.href = url;
      }
    }
  };

  const getBackendNotificationresponse = useSelector(
    (state) => state.auctionPage?.getBackendNotification
  );

  const backendNotificationAvailableResponse = useSelector(
    (state) => state.auctionPage?.backendNotificationAvailable
  );

  useEffect(() => {
    if (true == backendNotificationAvailableResponse) {
      let getBackendNotificationresponseData = getBackendNotificationresponse;
      setBackendNotification(getBackendNotificationresponseData);
      dispatch(backendNotificationAvailable(false));
      dispatch(getBackendNotification(""));
    }
  });
  // Performance code start
  const bidderInSuccess = useSelector(
    (state) => state.auctionPage?.bidderIn
  )

  const bidderOutSuccess = useSelector(
    (state) => state.auctionPage?.bidderOut
  )



  useEffect(() => {
    if (bidderInSuccess) {
      // Determine which one is active and the corresponding flag value

      let rowDetails = parseInt(
        (bidderInSuccess?.auctionItemDetailId || bidderOutSuccess?.auctionItemDetailId)
      );

      if (!auctionData) auctionData = allAuctionData || {};
      if (!allAuctionData) allAuctionData = auctionData || {};

      if (!auctionData.responseData)
        auctionData.responseData = allAuctionData.responseData || {};
      if (!allAuctionData.responseData)
        allAuctionData.responseData = auctionData.responseData || {};

      // Update only the item with matching auctionItemDetailId
      const updateLiveBidDetails = (bidData) => {
        return bidData.map((liveBid) => {
          if (liveBid.auctionItemDetailId !== rowDetails) return liveBid;
          return {
            ...liveBid,
            isItemSelected: 1,
          };
        });
      };

      let updatedData =
        activeTab === 5 || activeTab === 6
          ? allAuctionDataLiveBidDetails
            ? updateLiveBidDetails(allAuctionDataLiveBidDetails)
            : []
          : auctionDataLiveBidDetails
            ? updateLiveBidDetails(auctionDataLiveBidDetails)
            : [];

      // Update auctionData structure
      auctionData.responseData.liveBidDetails = updatedData;
      auctionDataColumnDetails = auctionData?.responseData?.columnDetails;
      auctionDataLiveBidDetails = auctionData?.responseData?.liveBidDetails;

      // Update allAuctionData structure
      allAuctionData.responseData.liveBidDetails = updatedData;
      allAuctionDataLiveBidDetails = updatedData;
      allAuctionDataColumnDetails = allAuctionData?.responseData?.columnDetails;
    }
  }, [bidderInSuccess]);

  useEffect(() => {
    if (!bidderOutSuccess) return;

    const rowDetails = parseInt(bidderOutSuccess.auctionItemDetailId);

    if (!auctionData) auctionData = allAuctionData || {};
    if (!allAuctionData) allAuctionData = auctionData || {};

    if (!auctionData.responseData)
      auctionData.responseData = allAuctionData.responseData || {};
    if (!allAuctionData.responseData)
      allAuctionData.responseData = auctionData.responseData || {};

    const updateLiveBidDetails = (bidData) => {
      return bidData.map((liveBid) => {
        if (liveBid.auctionItemDetailId !== rowDetails) return liveBid;

        else if (liveBid.isActive == 1)
          return {
            ...liveBid,
            isItemSelected: 2,
            itemColor: "out-button-lots-color"
          }
        return {
          ...liveBid,
          isItemSelected: 0,
        };
      });
    };

    let updatedData =
      activeTab === 5 || activeTab === 6
        ? allAuctionDataLiveBidDetails
          ? updateLiveBidDetails(allAuctionDataLiveBidDetails)
          : []
        : auctionDataLiveBidDetails
          ? updateLiveBidDetails(auctionDataLiveBidDetails)
          : [];

    console.log('updatedData', updatedData)

    auctionData.responseData.liveBidDetails = updatedData;
    auctionDataColumnDetails = auctionData?.responseData?.columnDetails;
    auctionDataLiveBidDetails = auctionData?.responseData?.liveBidDetails;

    allAuctionData.responseData.liveBidDetails = updatedData;
    allAuctionDataLiveBidDetails = updatedData;
    allAuctionDataColumnDetails = allAuctionData?.responseData?.columnDetails;

  }, [bidderOutSuccess]);

  // Performance code end
  const socketHandler = () => {
    let url =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_END_POINT_URL_DEV
        : process.env.REACT_APP_END_POINT_URL_PROD;

    // Connect to the server using SockJS
    const socket = new SockJS(
      url +
      "/auctionbid/connect?token=" +
      atob(sessionStorage.getItem("argument1"))
    );

    // Create a Stomp.js client over the WebSocket connection
    const stompClient = Stomp.over(socket);
    stompClient.debug = null;
    setStompClientForDisconnect(stompClient);

    // Function to subscribe to a static on the server
    const subscribeToStaticCall = () => {
      const subscriptionStaticData = stompClient.subscribe(
        `/auctionbid/broadcast/biddingdashboard/${auctionDetailId}`,
        (message) => {
          if (message.body) {
            console.log("static update called");

            // if (firstCall == 0) {
            //   firstCall = firstCall + 1;
            //   let payloadData = {
            //     userAuctionLoginId: auctionUserId,
            //     auctionDetailId: auctionDetailId,
            //   };
            //   dispatch(fetchAuctionCenterHeaderData(payloadData));
            // }

            const tempLiveBidDetailsData =
              auctionDataLiveBidDetails &&
              auctionDataLiveBidDetails.map(
                (liveBidDetailsData, liveBidDetailsIndex) => {
                  let currentBid = liveBidDetailsData.currentBid;
                  let increment = liveBidDetailsData.increment;
                  let itemColor = liveBidDetailsData.itemColor;
                  let l1Amount = liveBidDetailsData.l1Amount;
                  let maxBid = liveBidDetailsData.maxBid;
                  let isActive = liveBidDetailsData.isActive;
                  let noOfBidders = -1;

                  if (1 == isActive) {
                    let tempColumnDetailsData =
                      liveBidDetailsData &&
                      liveBidDetailsData.columnDetails &&
                      liveBidDetailsData.columnDetails.map(
                        (columnDetailsData, columnDetailsIndex) => {
                          if (33 == columnDetailsData.columnTypeId) {
                            noOfBidders = columnDetailsData.columnValue;
                          }

                          if (
                            10 == columnDetailsData.columnTypeId &&
                            1 == activeTab &&
                            "unsold-lots-color" != itemColor &&
                            "sold-lots-color" != itemColor
                          ) {
                            let startTime =
                              liveBidDetailsData &&
                              liveBidDetailsData.lotActivationTime;

                            let startDate = new Date();

                            if (startTime != undefined) {
                              startDate.setHours(
                                startTime &&
                                startTime.split(":") &&
                                startTime.split(":")[0]
                              );
                              startDate.setMinutes(
                                startTime &&
                                startTime.split(":") &&
                                startTime.split(":")[1]
                              );
                              startDate.setSeconds(
                                startTime &&
                                startTime.split(":") &&
                                startTime.split(":")[2]
                              );
                            }

                            let endDate = new Date();

                            let diffInMilliseconds =
                              new Date(endDate).getTime() -
                              new Date(startDate).getTime();

                            let diffInSeconds = Math.floor(
                              diffInMilliseconds / 1000
                            );

                            let hours = Math.floor(diffInSeconds / 3600);
                            let minutes = Math.floor(
                              (diffInSeconds % 3600) / 60
                            );
                            let seconds = diffInSeconds % 60;

                            let hoursString = hours < 10 ? "0" + hours : hours;
                            let minutesString =
                              minutes < 10 ? "0" + minutes : minutes;
                            let secondsString =
                              seconds < 10 ? "0" + seconds : seconds;

                            columnDetailsData.columnValue =
                              hoursString +
                              ":" +
                              minutesString +
                              ":" +
                              secondsString;
                          }

                          if (35 == columnDetailsData.columnTypeId) {
                            if (null != maxBid && 0 != maxBid) {
                              if (
                                currentBid + increment <= maxBid &&
                                "unsold-lots-color" != itemColor &&
                                "sold-lots-color" != itemColor &&
                                "out-button-lots-color" != itemColor &&
                                "active-lots-reached-max-bid-color" !=
                                itemColor &&
                                "winner-buyer-lots-color" != itemColor
                              ) {
                                columnDetailsData.columnValue =
                                  currentBid + increment;
                                liveBidDetailsData.currentBid =
                                  currentBid + increment;

                                if (columnDetailsData.columnValue > maxBid) {
                                  liveBidDetailsData.itemColor =
                                    "active-lots-reached-max-bid-color";
                                } else {
                                  let latestValue = maxBid - increment * 3;
                                  if (
                                    columnDetailsData.columnValue >= latestValue
                                  ) {
                                    liveBidDetailsData.itemColor =
                                      "max-bid-reached-lots-color";
                                  } else {
                                    liveBidDetailsData.itemColor =
                                      "active-lots-color";
                                  }
                                }
                              } else if (
                                "out-button-lots-color" == itemColor ||
                                "active-lots-reached-max-bid-color" == itemColor
                              ) {
                                columnDetailsData.columnValue =
                                  currentBid + increment;
                                liveBidDetailsData.currentBid =
                                  currentBid + increment;
                              }
                            } else {
                              if (
                                "unsold-lots-color" != itemColor &&
                                "sold-lots-color" != itemColor &&
                                "winner-buyer-lots-color" != itemColor &&
                                noOfBidders > 0
                              ) {
                                columnDetailsData.columnValue =
                                  currentBid + increment;
                                liveBidDetailsData.currentBid =
                                  currentBid + increment;

                                liveBidDetailsData.itemColor =
                                  "active-lots-color";
                              }
                            }
                          }

                          return columnDetailsData;
                        }
                      );
                  }
                  return liveBidDetailsData;
                }
              );

            const tempUpdatedLiveBidDetailsData = auctionData.responseData;
            tempUpdatedLiveBidDetailsData.liveBidDetails =
              tempLiveBidDetailsData;

            const tempAuctionData = auctionData;
            auctionData.responseData = tempUpdatedLiveBidDetailsData;

            auctionData = tempAuctionData;
            auctionDataColumnDetails = auctionData?.responseData?.columnDetails;
            auctionDataLiveBidDetails =
              auctionData?.responseData?.liveBidDetails;
            setfetchAuctionCenterDataApiCallResponse(true);
          }
        }
      );
    };

    // Function to subscribe to a dynamic on the server
    const subscribeToDynamicCall = () => {
      const subscriptionDynamicData = stompClient.subscribe(
        `/auctionbid/broadcast/biddingdashboarddyn/${auctionDetailId}`,
        (message) => {
          if (message.body) {
            console.log("dynamic update called");
            // if (firstCall == 0) {
            //   firstCall = firstCall + 1;
            // let payloadData = {
            //   userAuctionLoginId: auctionUserId,
            //   auctionDetailId: auctionDetailId,
            // };
            // dispatch(fetchAuctionCenterHeaderData(payloadData));
            // }

            // viewuserwiseliveauctionApiCall(1,0);
            if (4 == activeTab) {
              viewuserwiseliveauctionApiCall(4, 0);
            } else if (5 == activeTab) {
              viewuserwiseliveauctionApiCall(2, 0);
            } else if (6 == activeTab) {
              viewuserwiseliveauctionApiCall(3, 0);
            } else {
              viewuserwiseliveauctionApiCall(1, 0);
            }
            //If summary is open then call summary api
            if (true == isSummaryCalled) {
              handleSummaryOfTeaSoldModal(true);
            }

            //If planner is open then call planner api
            if (true == isPlannerCalled) {
              handlePlannerModal(true);
            }

            if (null != auctioneerWiseMarketSummary) {
              onClickOfAuctioneerMarketSummary(
                true,
                auctioneerWiseMarketSummary
              );
            }
            selectedDataForMyCatalog = [];
          }
        }
      );
      stompClient.subscribe(`/auctionbid/broadcast/itemUpdateOnly/${auctionDetailId}`,
        (message) => {
          if (message.body) {
            let rowDetails = parseInt(message.body.split("$$")[0]);
            let noOfBidders = message.body.split("$$")[1];

            if (!auctionData) auctionData = allAuctionData || {};
            if (!allAuctionData) allAuctionData = auctionData || {};

            if (!auctionData.responseData)
              auctionData.responseData = allAuctionData.responseData || {};
            if (!allAuctionData.responseData)
              allAuctionData.responseData = auctionData.responseData || {};


            // ✅ Update only columnTypeId === 33 for matching rowDetails
            const updateLiveBidDetails = (bidData) => {
              return bidData.map((liveBid) => {
                if (liveBid.auctionItemDetailId !== rowDetails) return liveBid;

                let updatedColumnDetails = liveBid.columnDetails
                  ? liveBid.columnDetails.map((columnData) => {
                    if (columnData.columnTypeId === 33) {
                      return {
                        ...columnData,
                        columnValue: noOfBidders, // ✅ Updated to noOfBidders
                      };
                    }
                    return columnData;
                  })
                  : liveBid.columnDetails;

                return {
                  ...liveBid,
                  columnDetails: updatedColumnDetails,
                };
              });
            };

            let updatedData =
              activeTab === 5 || activeTab === 6
                ? allAuctionDataLiveBidDetails
                  ? updateLiveBidDetails(allAuctionDataLiveBidDetails)
                  : []
                : auctionDataLiveBidDetails
                  ? updateLiveBidDetails(auctionDataLiveBidDetails)
                  : [];

            console.log('updatedData', updatedData)

            // ✅ Update auctionData structure
            auctionData.responseData.liveBidDetails = updatedData;
            auctionDataColumnDetails = auctionData?.responseData?.columnDetails;
            auctionDataLiveBidDetails = auctionData?.responseData?.liveBidDetails;

            // // ✅ Update allAuctionData structure
            allAuctionData.responseData.liveBidDetails = updatedData;
            allAuctionDataLiveBidDetails = updatedData;
            allAuctionDataColumnDetails = allAuctionData?.responseData?.columnDetails;
          }
        }
      );

      // ✅ Ensure auctionData and allAuctionData are always defined
    }

    //Function to hold auction
    const subscribeToHoldAuction = () => {
      stompClient.subscribe(
        `/auctionbid/broadcast/holdAuction/${auctionDetailId}`,
        (message) => {
          if (message.body) {
            console.log("hold auction called");
            isHoldAuctionCalled = true;
            // if (firstCall == 0) {
            //   firstCall = firstCall + 1;
            let payloadData = {
              userAuctionLoginId: auctionUserId,
              auctionDetailId: auctionDetailId,
            };
            dispatch(fetchAuctionCenterHeaderData(payloadData));
            // }
            // viewuserwiseliveauctionApiCall(1,0);
            if (4 == activeTab) {
              viewuserwiseliveauctionApiCall(4, 0);
            } else if (5 == activeTab) {
              viewuserwiseliveauctionApiCall(2, 0);
            } else if (6 == activeTab) {
              viewuserwiseliveauctionApiCall(3, 0);
            } else {
              viewuserwiseliveauctionApiCall(1, 0);
            }

            //If summary is open then call summary api
            if (true == isSummaryCalled) {
              handleSummaryOfTeaSoldModal(true);
            }

            //If planner is open then call planner api
            if (true == isPlannerCalled) {
              handlePlannerModal(true);
            }
            CustomToast.warning("Auction is on hold");
          }
        }
      );
    };

    //Function to get notification
    const subscribeToNotificationMessage = () => {
      stompClient.subscribe(
        `/auctionbid/broadcast/notificationMessage/${auctionDetailId}/${auctionUserId}`,
        (message) => {
          if (message.body) {
            console.log("subscribeToNotificationMessage called", message.body);
            // CustomToast.info(message.body);
            setBackendNotification(message.body);
          }
        }
      );
    };

    //Function to close auction notification
    const subscribeToCloseAuctionNotification = () => {
      stompClient.subscribe(
        `/auctionbid/broadcast/notificationMessage/${auctionDetailId}`,
        (message) => {
          if (message.body) {
            console.log("subscribeToNotificationMessage called", message.body);

            if ("Your current session has ended" == message.body.toString()) {
              setIsAuctionEnded(true);
              activeTab = 1;
              viewuserwiseliveauctionApiCall(1, 0);
            } else {
              setIsAuctionEnded(false);
            }

            CustomToast.info(message.body);
          }
        }
      );
    };

    // Function to call new session notification
    const subscribeTocallNewSessionNotification = () => {
      stompClient.subscribe(
        `/auctionbid/broadcast/auctionstartnotify/${auctionCenterId}`,
        (message) => {
          if (message.body) {
            console.log(
              "subscribeTocallNewSessionNotification called",
              message.body
            );
            let auctionDetailIdFromBody =
              message.body &&
              message.body.split(":") &&
              message.body.split(":")[0] &&
              parseInt(message.body.split(":")[0]);

            let sessionDetailIdFromBody =
              message.body &&
              message.body.split(":") &&
              message.body.split(":")[1];

            getDashboardDetailsForLiveAndWarmUpStatus(
              auctionDetailIdFromBody,
              sessionDetailIdFromBody
            );
          }
        }
      );
    };

    const subscribeToGetHeaderData = () => {
      stompClient.subscribe(
        `/auctionbid/broadcast/getAuctionDetailIdWiseHeaderData/${auctionDetailId}`,
        (message) => {
          if (message.body) {
            console.log("subscribeToGetHeaderData called", message.body);
            let jsonData = JSON.parse(message.body);
            setFetchAuctionCenterHeaderDataResponse(jsonData);
          }
        }
      );
    };

    // Connect to the WebSocket server
    stompClient.connect({}, () => {
      console.log("Connected to WebSocket server");
      subscribeToStaticCall();
      subscribeToDynamicCall();
      subscribeToHoldAuction();
      subscribeToNotificationMessage();
      subscribeToCloseAuctionNotification();
      subscribeTocallNewSessionNotification();
      subscribeToGetHeaderData();

      if (
        0 != auctionDetailId &&
        null != auctionDetailId &&
        "null" != auctionDetailId &&
        0 != auctionUserId &&
        null != auctionUserId &&
        "null" != auctionUserId
      ) {
        const fetchHeaderData = () => {
          stompClient.send(
            "/auctionbid/send/getAuctionHeaderData",
            {},
            auctionDetailId
          );
        };

        fetchHeaderData();
        intervalId = setInterval(fetchHeaderData, 1000);

        return () => clearInterval(intervalId);
      }
    });

    // Clean up function
    return () => {
      // Close the WebSocket connection when the component unmounts
      if (stompClientForDisconnect) {
        stompClientForDisconnect.disconnect();
      }
    };
  };

  if (socket) {
    socket = false;
    socketHandler();
    // if (
    //   0 != auctionDetailId &&
    //   null != auctionDetailId &&
    //   0 != auctionUserId &&
    //   null != auctionUserId &&
    //   auctionDataLiveBidDetails != null
    // ) {
    //   CustomToast.info("Your new session has started");
    // }
  }

  const handleButton = (name, data) => {
    console.log("handleButton 69", data);
    switch (name) {
      case "confirm": {
        console.log("handleButton in confirm", data);

        let maxBid = 0;

        data &&
          data.columnDetails &&
          data.columnDetails.map((columnDetailsData, columnDetailsIndex) => {
            if (42 == columnDetailsData.columnTypeId) {
              maxBid = columnDetailsData.columnValue;
            }
          });

        console.log("data.auctionItemDetailId 845", data.auctionItemDetailId);
        const existingMaxBids =
          JSON.parse(localStorage.getItem("maxBids")) || {};
        let existingMaxBid = existingMaxBids[data.auctionItemDetailId];

        console.log("maxBid 845", maxBid);
        console.log("existingMaxBid 845", existingMaxBid);

        if (existingMaxBid != undefined && maxBid != existingMaxBid) {
          maxBid = existingMaxBid;
        }

        if (!maxBid.toString().match(/^[0-9]*$/)) {
          CustomToast.error("Please enter valid bid price");
          break;
        }

        let payloadData = {
          auctionItemDetailId: data.auctionItemDetailId,
          bidderId: auctionUserId,
          maxBid: maxBid,
        };

        dispatch(bidderConfirm(payloadData));
        break;
      }

      case "in": {
        console.log("handleButton in in", data);
        let maxBid = 0;

        data &&
          data.columnDetails &&
          data.columnDetails.map((columnDetailsData, columnDetailsIndex) => {
            if (42 == columnDetailsData.columnTypeId) {
              maxBid = columnDetailsData.columnValue;
            }
          });

        if (maxBid == null) {
          const existingMaxBids =
            JSON.parse(localStorage.getItem("maxBids")) || {};
          console.log("hello 874", JSON.parse(localStorage.getItem("maxBids")));
          console.log("hello 875", existingMaxBids);
          console.log("hello 876", existingMaxBids[data.auctionItemDetailId]);
          maxBid = existingMaxBids[data.auctionItemDetailId];
        }

        if (maxBid != null && !maxBid.toString().match(/^[0-9]*$/)) {
          CustomToast.error("Please enter valid bid price");
          break;
        }

        let payloadData = {
          auctionItemDetailId: data.auctionItemDetailId,
          bidderId: auctionUserId,
          maxBid: maxBid,
          commonUserId: atob(sessionStorage.getItem("argument2")),
        };

        dispatch(bidderIn(payloadData));
        break;
      }

      case "out": {
        console.log("handleButton in out", data);
        let payloadData = {
          auctionItemDetailId: data.auctionItemDetailId,
          bidderId: auctionUserId,
        };

        dispatch(bidderOut(payloadData));
        break;
      }

      case "removeFromMyCatalogAuctionBid": {
        let payloadData = {
          auctionItemDetailId: data.auctionItemDetailId,
          buyerId: auctionUserId,
          auctionDetailId: auctionDetailId,
          auctionCenterId: auctionCenterId,
        };

        dispatch(removeFromMyCatalogAuctionBid(payloadData));
        break;
      }

      case "addToMyCatalogAuctionBid": {
        if (selectedDataForMyCatalog && selectedDataForMyCatalog.length > 0) {
          let payloadData = {
            auctionItemDetailId: data.auctionItemDetailId,
            bidderId: atob(sessionStorage.getItem("argument2")),
            auctionDetailId: auctionDetailId,
            auctionCenterId: auctionCenterId,
            auctionItemDetailIdList: selectedDataForMyCatalog,
          };

          dispatch(addToMyCatalogAuctionBid(payloadData));
        } else {
          CustomToast.error("Please select at least one lot");
        }

        break;
      }

      case "viewBidBook": {
        setIsShownBidBook(data);
        break;
      }

      case "restoreSetting": {
        setLoader(true);
        let payloadData = {
          userLoginId: auctionUserId,
          auctionDetailId: auctionDetailId,
          type: activeTab,
        };
        dispatch(getAndSetUserWiseDefaultColumnConfig(payloadData));
        break;
      }

      default: {
        break;
      }
    }
  };

  const handleChange = (
    data,
    auctionItemDetailId,
    columnTypeId,
    value,
    key
  ) => {
    if (5 == activeTab || 6 == activeTab) {
      let tempLiveBidDetailsData =
        allAuctionData &&
        allAuctionData.responseData &&
        allAuctionData.responseData.liveBidDetails &&
        allAuctionData.responseData.liveBidDetails.map(
          (liveBidDetailsData, liveBidDetailsIndex) => {
            if (auctionItemDetailId == liveBidDetailsData.auctionItemDetailId) {
              let tempColumnDetailsData =
                liveBidDetailsData &&
                liveBidDetailsData.columnDetails &&
                liveBidDetailsData.columnDetails.map(
                  (columnDetailsData, columnDetailsIndex) => {
                    if (columnTypeId == columnDetailsData.columnTypeId) {
                      columnDetailsData[key] = value;
                    }

                    return columnDetailsData;
                  }
                );
            }

            return liveBidDetailsData;
          }
        );

      let tempUpdatedLiveBidDetailsData = allAuctionData.responseData;
      tempUpdatedLiveBidDetailsData.liveBidDetails = tempLiveBidDetailsData;

      let tempAuctionData = allAuctionData;
      tempAuctionData.responseData = tempUpdatedLiveBidDetailsData;

      allAuctionData = tempAuctionData;
      allAuctionDataColumnDetails = allAuctionData?.responseData?.columnDetails;
      allAuctionDataLiveBidDetails =
        allAuctionData?.responseData?.liveBidDetails;
      setAllFetchAuctionCenterDataApiCallResponse(true);
    } else {
      let tempLiveBidDetailsData =
        auctionData &&
        auctionData.responseData &&
        auctionData.responseData.liveBidDetails &&
        auctionData.responseData.liveBidDetails.map(
          (liveBidDetailsData, liveBidDetailsIndex) => {
            if (auctionItemDetailId == liveBidDetailsData.auctionItemDetailId) {
              let tempColumnDetailsData =
                liveBidDetailsData &&
                liveBidDetailsData.columnDetails &&
                liveBidDetailsData.columnDetails.map(
                  (columnDetailsData, columnDetailsIndex) => {
                    if (columnTypeId == columnDetailsData.columnTypeId) {
                      columnDetailsData[key] = value;
                    }

                    return columnDetailsData;
                  }
                );
            }

            return liveBidDetailsData;
          }
        );

      let tempUpdatedLiveBidDetailsData = auctionData.responseData;
      tempUpdatedLiveBidDetailsData.liveBidDetails = tempLiveBidDetailsData;

      let tempAuctionData = auctionData;
      tempAuctionData.responseData = tempUpdatedLiveBidDetailsData;

      auctionData = tempAuctionData;
      auctionDataColumnDetails = auctionData?.responseData?.columnDetails;
      auctionDataLiveBidDetails = auctionData?.responseData?.liveBidDetails;
      setfetchAuctionCenterDataApiCallResponse(true);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedDataForMyCatalog.includes(id)) {
      let tempData = selectedDataForMyCatalog.filter((data) => data != id);
      selectedDataForMyCatalog = tempData;
    } else {
      selectedDataForMyCatalog.push(id);
    }
    setfetchAuctionCenterDataApiCallResponse(true);
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleModal = (value) => {
    setShow(value);

    if (true == value) {
      setLeftNo(0);
      setRightNo(0);
      setStickyInput({
        leftNo: 0,
        rightNo: 0,
      });

      let payloadData = {
        userLoginId: auctionUserId,
        auctionDetailId: auctionDetailId,
        type: activeTab,
      };
      dispatch(catelogFetchAllData(payloadData));
    } else {
      setLeftNo(0);
      setRightNo(0);
      setStickyInput({
        leftNo: 0,
        rightNo: 0,
      });
    }
  };

  const catelogFetchAllDataResponses = useSelector(
    (state) => state.auctionPage?.catelogFetchAllData
  );

  const catelogFetchAllDataResponse = useSelector(
    (state) => state.auctionPage?.catelogFetchAllData?.responseData
  );

  const selectRecord = (key, value, columnTypeId) => {
    let tempData =
      catelogFetchAllDataResponse &&
      catelogFetchAllDataResponse.map((innerData, innerIndex) => {
        if (columnTypeId == innerData.columnTypeId) {
          innerData[key] = value;
        }
        return innerData;
      });

    let updateData = catelogFetchAllDataResponses;
    catelogFetchAllDataResponses.responseData = tempData;
    dispatch(catelogFetchAllDataSuccess(updateData));
  };

  const handleStickySubmit = () => {
    setRightNo(stickyInput.rightNo);
    setLeftNo(stickyInput.leftNo);
    // handleModal(false);
    setShow(false);

    //For filtered is shown 1 data
    let catelogFetchAllDataResponseFilterData = [];

    let catelogFetchAllDataResponseFilterIds = [];
    catelogFetchAllDataResponse &&
      catelogFetchAllDataResponse.map(
        (catelogFetchAllDataResponseData, catelogFetchAllDataResponseIndex) => {
          if (catelogFetchAllDataResponseData.isShown) {
            catelogFetchAllDataResponseFilterData.push(
              catelogFetchAllDataResponseData
            );
            catelogFetchAllDataResponseFilterIds.push(
              catelogFetchAllDataResponseData.columnTypeId
            );
          }
        }
      );

    //To set left columns locked
    for (let i = 0; i < catelogFetchAllDataResponseFilterData.length; i++) {
      if (i < stickyInput.leftNo) {
        catelogFetchAllDataResponseFilterData[i].isLocked = 1;
      } else {
        catelogFetchAllDataResponseFilterData[i].isLocked = 0;
      }
    }

    let tempFixedColumnData = catelogFetchAllDataResponseFilterData?.map(
      (item) => ({
        ...item,
        title: item.name,
      })
    );

    //To set right columns locked
    let rightLength = tempFixedColumnData.length - (stickyInput.rightNo + 1);
    for (let i = tempFixedColumnData.length - 1; i > rightLength; i--) {
      catelogFetchAllDataResponseFilterData[i].isLocked = 1;
    }

    let tempAllData = catelogFetchAllDataResponseFilterData;
    if (
      catelogFetchAllDataResponseFilterIds &&
      catelogFetchAllDataResponseFilterIds.length > 0
    ) {
      catelogFetchAllDataResponse &&
        catelogFetchAllDataResponse.map(
          (
            catelogFetchAllDataResponseData,
            catelogFetchAllDataResponseIndex
          ) => {
            if (
              !catelogFetchAllDataResponseFilterIds.includes(
                catelogFetchAllDataResponseData.columnTypeId
              )
            ) {
              tempAllData.push(catelogFetchAllDataResponseData);
            }
          }
        );
    }

    let payloadData = {
      userLoginId: auctionUserId,
      auctionDetailId: auctionDetailId,
      userAuctionLoginId: auctionUserId,
      catalogColumnConfigurationDetails: tempAllData,
      type: activeTab,
    };

    dispatch(catelogSubmitData(payloadData));
  };

  const handleSummaryOfTeaSoldModal = (value) => {
    setdataMenu(value);
    isSummaryCalled = value;

    if (true == value) {
      let payloadData = {
        auctionDetailId: auctionDetailId,
        userAuctionLoginId: auctionUserId,
      };

      dispatch(getSummaryOfTeaSoldData(payloadData));
      dispatch(getAuctioneerMarketSummaryData(payloadData));
      dispatch(getMarketSummaryData(payloadData));
    } else {
      handleTabClick(1);
      onClickOfAuctioneerMarketSummary(false, []);
    }
  };

  const onClickOfAuctioneerMarketSummary = (flag, data) => {
    if (flag) {
      let payloadData = {
        auctionDetailId: auctionDetailId,
        userLoginId: data.commonUserId,
      };
      setAuctioneerMarketWiseSummaryDataValue(data.auctioneerCode);
      dispatch(getAuctioneerMarketSummaryWiseData(payloadData));
      auctioneerWiseMarketSummary = data;
    } else {
      dispatch(getAuctioneerMarketSummaryWiseDataSuccess([]));
      setAuctioneerMarketWiseSummaryDataValue("");
      auctioneerWiseMarketSummary = null;
    }
    setShowAuctioneerMarketWiseSummaryData(flag);
  };

  const getSummaryOfTeaSoldDataResponse = useSelector(
    (state) => state.auctionPage?.getSummaryOfTeaSoldData?.responseData
  );

  const getAuctioneerMarketSummaryDataResponse = useSelector(
    (state) => state.auctionPage?.getAuctioneerMarketSummaryData?.responseData
  );

  const getAuctioneerMarketSummaryWiseDataResponse = useSelector(
    (state) =>
      state.auctionPage?.getAuctioneerMarketSummaryWiseData?.responseData
  );

  const getMarketSummaryDataResponse = useSelector(
    (state) => state.auctionPage?.getMarketSummaryData?.responseData
  );

  const handlePlannerModal = (value) => {
    console.log("value 1252", value);
    setdataMenu(value);
    isPlannerCalled = true;
    if (true == value) {
      let payloadData = {
        auctionDetailId: auctionDetailId,
        bidderId: auctionUserId,
        type: 0,
      };

      dispatch(getMyPlannerData(payloadData));
    } else {
      handleTabClick(1);
    }
  };

  const getMyPlannerDataResponse = useSelector(
    (state) => state.auctionPage?.getMyPlannerData?.responseData
  );

  const handleMyCatalogModal = (value) => {
    setdataMenu(value);
    handleTabClick(1);
  };

  const moduleList = useSelector(
    (state) => state?.ModuleReducer?.data?.responseData
  );

  const [rightsIdData, setRightsIdData] = useState([]);

  if (
    moduleList !== null &&
    moduleList !== undefined &&
    rightsIdData?.length == 0
  ) {
    setRightsIdData(
      moduleList?.auctionCentersList
        ?.map((auctionCenters) => auctionCenters.modulesDtoList)
        ?.at(0)
        ?.filter((modulesDto) => modulesDto.moduleid == 3)
        ?.at(0)
        ?.linksDtoList?.filter((linksDto) => linksDto.linkId == 52)
        ?.at(0)?.rightIds
    );
  }

  const handleExport = () => {
    setLoader(true);
    viewuserwiseliveauctionApiCall(
      5 == activeTab ? 2 : 6 == activeTab ? 3 : 4 == activeTab ? 4 : 1,
      1
    );
  };

  const handlePlannerExport = (type) => {
    let payloadData = {
      auctionDetailId: auctionDetailId,
      bidderId: auctionUserId,
      type: type,
    };
    generalType = type;
    dispatch(getMyPlannerData(payloadData));
  };

  let myPlannerExportDataResponse = useSelector(
    (state) => state.auctionPage?.getMyPlannerExportData?.responseData
  );

  let myPlannerExportDataAPIResponseSelector = useSelector(
    (state) => state.auctionPage?.myPlannerExportDataAPIResponse
  );

  useEffect(() => {
    if (true == myPlannerExportDataAPIResponseSelector) {
      if (1 == generalType) {
        let exportFileData = myPlannerExportDataResponse?.exported_file;
        if (exportFileData != null) {
          Base64ToExcelDownload(exportFileData, "MyPlannerData.xlsx");
        }
      } else if (2 == generalType) {
        let exportFileData = myPlannerExportDataResponse?.exported_file;
        if (exportFileData != null) {
          uploadedFileDownload(
            exportFileData,
            "MyPlannerData.pdf",
            `data:application/pdf;base64`
          );
        }
      }
      dispatch(myPlannerExportDataAPIResponse(false));
    }
  });

  const countForShowMethod = () => {
    isCountForShow = true;
    countForShow = 1;
  };
  useEffect(() => {
    if (isCountForShow) {
      isCountForShow = false;
      CustomToast.info("Max bid price less than Base price");
    }
  });

  return (
    <>
      {0 == auctionDetailId ||
        null == auctionDetailId ||
        "null" == auctionDetailId ||
        0 == auctionUserId ||
        null == auctionUserId ||
        "null" == auctionUserId ? (
        <div className="d-flex justify-content-center align-items-center noAuctionDiv text-muted">
          No Auction Today
        </div>
      ) : (
        <>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title>Table Setting</Modal.Title>
              <i
                className="fa fa-times CloseModal"
                onClick={() => handleModal(false)}
              ></i>
            </Modal.Header>

            <Modal.Body>
              <div className="row">
                {/* <div className="col-md-6">
                  <div class="FomrGroup">
                    <label>Left Column</label>
                    <input
                      type="text"
                      className="form-control"
                      min={0}
                      max={columns && columns.length && columns.length / 2}
                      value={stickyInput.leftNo >= 0 ? stickyInput.leftNo : ""}
                      onChange={(e) =>
                        setStickyInput({
                          ...stickyInput,
                          leftNo:
                            e.target.value <= columns?.length
                              ? parseFloat(e.target.value)
                              : "",
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div class="FomrGroup">
                    <label>Right Column</label>
                    <input
                      type="text"
                      className="form-control"
                      value={
                        stickyInput.rightNo >= 0 ? stickyInput.rightNo : ""
                      }
                      min={0}
                      max={columns && columns.length && columns.length / 2}
                      onChange={(e) =>
                        setStickyInput({
                          ...stickyInput,
                          rightNo:
                            e.target.value <= columns?.length
                              ? parseFloat(e.target.value)
                              : "",
                        })
                      }
                    />
                  </div>
                </div> */}

                <div class="col-md-12">
                  <div class="CardBox">
                    <h5 class="SmallTitle">Select Column</h5>
                    <ul>
                      {catelogFetchAllDataResponse &&
                        catelogFetchAllDataResponse.map((data, index) => (
                          <li>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="isShown"
                                value={data.isShown}
                                id={data.columnTypeId}
                                checked={data.isShown == 1 ? true : false}
                                onChange={(event) => {
                                  selectRecord(
                                    event.target.name,
                                    event.target.checked == true ? 1 : 0,
                                    data.columnTypeId
                                  );
                                }}
                                disabled={data.isEditable == 0 ? true : false}
                              />
                              <label className="ml-2">{data.columnName}</label>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="SubmitBtn"
                onClick={() => handleStickySubmit()}
              >
                Apply
              </Button>
              <Button
                className="SubmitBtn"
                onClick={() => handleButton("restoreSetting")}
              >
                Restore Defaults
              </Button>
            </Modal.Footer>
          </Modal>

          <div className="container-fluid-">
            <div className="header-Bharat">
              {fetchAuctionCenterHeaderDataResponse &&
                false == fetchAuctionCenterHeaderDataResponse.isTimeAvailable &&
                !isHoldAuctionCalled ? (
                <>
                  {fetchAuctionCenterHeaderDataResponse &&
                    fetchAuctionCenterHeaderDataResponse.cstatus &&
                    3 != fetchAuctionCenterHeaderDataResponse.cstatus &&
                    !isAuctionEnded ? (
                    <>
                      <span>
                        <b>Your current session is running</b>
                      </span>
                      <span className="divider"></span>
                      <span>
                        <b>
                          Current session end time may vary due to dynamic
                          session
                        </b>
                      </span>
                      <span className="divider"></span>
                    </>
                  ) : (
                    <>
                      <span>
                        <b>Your current session has ended</b>
                      </span>
                      <span className="divider"></span>
                    </>
                  )}
                </>
              ) : (
                ""
              )}

              <span>
                <b>MBT :</b>
                {fetchAuctionCenterHeaderDataResponse &&
                  fetchAuctionCenterHeaderDataResponse.mbt}
              </span>
              <span className="divider"></span>

              {(fetchAuctionCenterHeaderDataResponse &&
                true == fetchAuctionCenterHeaderDataResponse.isTimeAvailable) ||
                isHoldAuctionCalled ? (
                ""
              ) : (
                <>
                  <span>
                    <b>Remaining Time :</b>
                    {fetchAuctionCenterHeaderDataResponse &&
                      fetchAuctionCenterHeaderDataResponse.cstatus &&
                      3 != fetchAuctionCenterHeaderDataResponse.cstatus &&
                      !isAuctionEnded
                      ? fetchAuctionCenterHeaderDataResponse &&
                      fetchAuctionCenterHeaderDataResponse.rt
                      : "00:00:00"}
                  </span>
                  <span className="divider"></span>
                </>
              )}

              <span>
                <b>Season :</b>
                {fetchAuctionCenterHeaderDataResponse &&
                  fetchAuctionCenterHeaderDataResponse.season}
              </span>
              <span className="divider"></span>

              <span>
                <b>Sale No :</b>
                {fetchAuctionCenterHeaderDataResponse &&
                  fetchAuctionCenterHeaderDataResponse.saleNo}
              </span>
              <span className="divider"></span>

              <span>
                <b>Auction Date :</b>
                {fetchAuctionCenterHeaderDataResponse &&
                  fetchAuctionCenterHeaderDataResponse.auctionDate}
              </span>
              <span className="divider"></span>

              <span>
                <b>Current Session Time :</b>
                {fetchAuctionCenterHeaderDataResponse &&
                  fetchAuctionCenterHeaderDataResponse.currentSessionTime}
              </span>
            </div>
          </div>

          <div
            className={activeClass ? "active MainComponent" : "MainComponent "}
          >
            <div className="AuctionScreen">
              <div className="TabsMenu">
                <ul>
                  {rightsIdData &&
                    rightsIdData.length > 0 &&
                    rightsIdData?.includes("43") ? (
                    <li
                      className={`${activeTab === 1 ? "active" : ""}`}
                      onClick={() => handleTabClick(1)}
                    >
                      Auction Catalog
                    </li>
                  ) : (
                    ""
                  )}

                  {rightsIdData &&
                    rightsIdData.length > 0 &&
                    rightsIdData?.includes("44") ? (
                    <li
                      className={`${activeTab === 2 ? "active" : ""}`}
                      onClick={() => handleTabClick(2)}
                    >
                      Summary
                    </li>
                  ) : (
                    ""
                  )}

                  {rightsIdData &&
                    rightsIdData.length > 0 &&
                    rightsIdData?.includes("45") ? (
                    <li
                      className={`${activeTab === 3 ? "active" : ""}`}
                      onClick={() => handleTabClick(3)}
                    >
                      My Planner
                    </li>
                  ) : (
                    ""
                  )}

                  {rightsIdData &&
                    rightsIdData.length > 0 &&
                    rightsIdData?.includes("82") ? (
                    <li
                      className={`${activeTab === 4 ? "active" : ""}`}
                      onClick={() => handleTabClick(4)}
                    >
                      My Catalog
                    </li>
                  ) : (
                    ""
                  )}

                  {/* {rightsIdData?.includes("43") ? (
                    <li
                      className={`${activeTab === 5 ? "active" : ""}`}
                      onClick={() => handleTabClick(5)}
                    >
                      Pending Lots
                    </li>
                  ) : (
                    ""
                  )}

                  {rightsIdData?.includes("43") ? (
                    <li
                      className={`${activeTab === 6 ? "active" : ""}`}
                      onClick={() => handleTabClick(6)}
                    >
                      Sold/Unsold Lots
                    </li>
                  ) : (
                    ""
                  )} */}
                </ul>

                <div>
                  {1 == userCurrentStatus ? (
                    <>
                      {rightsIdData &&
                        rightsIdData.length > 0 &&
                        rightsIdData?.includes("82") ? (
                        <Button
                          className="SubmitBtn"
                          onClick={() =>
                            handleButton("addToMyCatalogAuctionBid", "")
                          }
                        >
                          Add To My Catalog
                        </Button>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {rightsIdData &&
                    rightsIdData.length > 0 &&
                    rightsIdData?.includes("83") ? (
                    <Button
                      className="SubmitBtn"
                      onClick={() => handleButton("viewBidBook", true)}
                    >
                      View Bid Book
                    </Button>
                  ) : (
                    ""
                  )}

                  {1 == userCurrentStatus ? (
                    <button class="SubmitBtn" onClick={() => handleExport()}>
                      <i class="fa fa-file-excel"></i>
                    </button>
                  ) : (
                    ""
                  )}

                  {1 == userCurrentStatus ? (
                    <>
                      {rightsIdData &&
                        rightsIdData.length > 0 &&
                        rightsIdData?.includes("46") ? (
                        <a
                          className="TableSetting"
                          onClick={() => handleModal(true)}
                        >
                          <i class="fa fa-wrench" aria-hidden="true"></i>
                        </a>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {loader ? (
                <>
                  <div className="text-center">
                    <ThreeDots
                      visible={true}
                      height="80"
                      width="80"
                      color="#4fa94d"
                      radius="9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                </>
              ) : (
                <div className="LiveAuction">
                  {1 == activeTab || 2 == activeTab || 3 == activeTab ? (
                    // ||4 == activeTab
                    <>
                      <div
                        className={`TableBox ${activeTab != 1 ? "active" : ""}`}
                      >
                        {auctionDataColumnDetails?.length > 0 ? (
                          <>
                            <AuctionTable
                              auctionDataColumnDetails={
                                auctionDataColumnDetails
                              }
                              auctionDataLiveBidDetails={
                                auctionDataLiveBidDetails
                              }
                              handleChange={handleChange}
                              handleButton={handleButton}
                              isHoldAuctionCalled={isHoldAuctionCalled}
                              isTimeAvailable={
                                fetchAuctionCenterHeaderDataResponse &&
                                fetchAuctionCenterHeaderDataResponse.isTimeAvailable
                              }
                              activeTab={activeTab}
                              handleSelectRow={handleSelectRow}
                              selectedDataForMyCatalog={
                                selectedDataForMyCatalog
                              }
                              fetchAuctionCenterDataApiCallResponse={
                                fetchAuctionCenterDataApiCallResponse
                              }
                              countForShowMethod={countForShowMethod}
                              countForShow={countForShow}
                              userCurrentStatus={userCurrentStatus}
                              auctionUserId={auctionUserId}
                              auctionDetailId={auctionDetailId}
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      <div
                        className={`LiveAuctionMenu ${activeTab === 2 ? "active " : ""
                          } ${activeClass && "ShowSideBar"}`}
                      >
                        {activeTab === 2 && (
                          <div className="Summery">
                            <span
                              class="Close"
                              onClick={() => {
                                handleSummaryOfTeaSoldModal(false);
                              }}
                            >
                              x
                            </span>
                            <div className="row">
                              {/* Summary of Tea Sold */}
                              <div className="col-lg-4">
                                <div className="Shadow">
                                  <div className="Title">
                                    Summary of Tea Sold
                                  </div>
                                  <SummaryOfTeaSoldDataTable
                                    getSummaryOfTeaSoldDataResponse={
                                      getSummaryOfTeaSoldDataResponse
                                    }
                                  />
                                </div>
                              </div>

                              {/* Auctioneer Market Summary */}
                              <div className="col-lg-4">
                                <div className="Shadow">
                                  <div className="Title">
                                    {true ==
                                      showAuctioneerMarketWiseSummaryData ? (
                                      <span
                                        class="fa fa-angle-left"
                                        onClick={() => {
                                          onClickOfAuctioneerMarketSummary(
                                            false,
                                            []
                                          );
                                        }}
                                      ></span>
                                    ) : (
                                      ""
                                    )}{" "}
                                    Auctioneer Market Summary
                                    {true == showAuctioneerMarketWiseSummaryData
                                      ? ` - ${auctioneerMarketWiseSummaryDataValue}`
                                      : ""}
                                  </div>
                                  {false ==
                                    showAuctioneerMarketWiseSummaryData ? (
                                    <ul className="AuctioneerList">
                                      {getAuctioneerMarketSummaryDataResponse !=
                                        null ? (
                                        <>
                                          {getAuctioneerMarketSummaryDataResponse &&
                                            getAuctioneerMarketSummaryDataResponse.map(
                                              (
                                                auctioneerMarketSummaryData,
                                                auctioneerMarketSummaryIndex
                                              ) => (
                                                <li
                                                  onClick={() =>
                                                    onClickOfAuctioneerMarketSummary(
                                                      true,
                                                      auctioneerMarketSummaryData
                                                    )
                                                  }
                                                >
                                                  {
                                                    auctioneerMarketSummaryData.auctioneerCode
                                                  }
                                                </li>
                                              )
                                            )}
                                        </>
                                      ) : (
                                        "No data available"
                                      )}
                                    </ul>
                                  ) : (
                                    <Table striped bordered hover>
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th>No. of Lots</th>
                                          <th>Pkgs</th>
                                          <th>Kgs</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {getAuctioneerMarketSummaryWiseDataResponse !=
                                          null ? (
                                          <>
                                            {getAuctioneerMarketSummaryWiseDataResponse &&
                                              getAuctioneerMarketSummaryWiseDataResponse.map(
                                                (
                                                  auctioneerMarketSummaryWiseData,
                                                  auctioneerMarketSummaryWiseDataIndex
                                                ) => (
                                                  <>
                                                    {auctioneerMarketSummaryWiseDataIndex !=
                                                      4 ? (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              auctioneerMarketSummaryWiseData.columnName
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              auctioneerMarketSummaryWiseData.noOfLots
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              auctioneerMarketSummaryWiseData.noOfPackages
                                                            }
                                                          </td>{" "}
                                                          <td>
                                                            {
                                                              auctioneerMarketSummaryWiseData.totalKgs
                                                            }
                                                          </td>
                                                        </tr>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              auctioneerMarketSummaryWiseData.columnName
                                                            }
                                                          </td>
                                                          <td colspan="3">
                                                            {
                                                              auctioneerMarketSummaryWiseData.averagePrice
                                                            }
                                                          </td>
                                                        </tr>
                                                      </>
                                                    )}
                                                  </>
                                                )
                                              )}
                                          </>
                                        ) : (
                                          "No data available"
                                        )}
                                      </tbody>
                                    </Table>
                                  )}
                                </div>
                              </div>

                              {/* Market Summary */}
                              <div className="col-lg-4">
                                <div className="Shadow">
                                  <div className="Title">Market Summary</div>
                                  <div className="TableBox">
                                    <Table striped bordered hover>
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th>No. of Lots</th>
                                          <th>Pkgs</th>
                                          <th>Kgs</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {getMarketSummaryDataResponse !=
                                          null ? (
                                          <>
                                            {getMarketSummaryDataResponse &&
                                              getMarketSummaryDataResponse.map(
                                                (
                                                  marketSummaryData,
                                                  marketSummaryDataIndex
                                                ) => (
                                                  <>
                                                    {marketSummaryDataIndex ==
                                                      5 ? (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              marketSummaryData.columnName
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              marketSummaryData.averagePrice
                                                            }
                                                          </td>
                                                          <td></td>
                                                          <td></td>
                                                        </tr>
                                                      </>
                                                    ) : marketSummaryDataIndex ==
                                                      6 ? (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              marketSummaryData.columnName
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              marketSummaryData.successfulBiddersCount
                                                            }
                                                          </td>
                                                          <td></td>
                                                          <td></td>
                                                        </tr>
                                                      </>
                                                    ) : marketSummaryDataIndex ==
                                                      0 &&
                                                      fetchAuctionCenterHeaderDataResponse &&
                                                      true ==
                                                      fetchAuctionCenterHeaderDataResponse.isTimeAvailable ? (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              marketSummaryData.columnName
                                                            }
                                                          </td>
                                                          <td>0</td>
                                                          <td>0</td>
                                                          <td>0</td>
                                                        </tr>
                                                      </>
                                                    ) : marketSummaryDataIndex ==
                                                      1 &&
                                                      fetchAuctionCenterHeaderDataResponse &&
                                                      true ==
                                                      fetchAuctionCenterHeaderDataResponse.isTimeAvailable ? (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              marketSummaryData.columnName
                                                            }
                                                          </td>
                                                          <td>
                                                            {getMarketSummaryDataResponse[0]
                                                              .noOfLots +
                                                              getMarketSummaryDataResponse[1]
                                                                .noOfLots}
                                                          </td>
                                                          <td>
                                                            {getMarketSummaryDataResponse[0]
                                                              .noOfPackages +
                                                              getMarketSummaryDataResponse[1]
                                                                .noOfPackages}
                                                          </td>
                                                          <td>
                                                            {getMarketSummaryDataResponse[0]
                                                              .totalKgs +
                                                              getMarketSummaryDataResponse[1]
                                                                .totalKgs}
                                                          </td>
                                                        </tr>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            {
                                                              marketSummaryData.columnName
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              marketSummaryData.noOfLots
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              marketSummaryData.noOfPackages
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              marketSummaryData.totalKgs
                                                            }
                                                          </td>
                                                        </tr>
                                                      </>
                                                    )}
                                                  </>
                                                )
                                              )}
                                          </>
                                        ) : (
                                          "No data available"
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div
                        className={`LiveAuctionMenu ${activeTab === 3 ? "active " : ""
                          } ${activeClass && "ShowSideBar"}`}
                      >
                        {activeTab === 3 && (
                          <div className="Summery">
                            <span
                              class="Close"
                              onClick={() => {
                                handlePlannerModal(false);
                              }}
                            >
                              x
                            </span>
                            <div className="row">
                              {/* My Planner Data */}
                              <div className="col-lg-12">
                                <div className="Shadow">
                                  <div className="Title">My Planner</div>

                                  {1 == userCurrentStatus ? (
                                    <div className="col-md-12 mt-2">
                                      <div className="BtnGroup">
                                        <button
                                          class="SubmitBtn"
                                          onClick={() => handlePlannerExport(1)}
                                        >
                                          <i class="fa fa-file-excel"></i>
                                        </button>

                                        <button
                                          class="SubmitBtn ml-2"
                                          onClick={() => handlePlannerExport(2)}
                                        >
                                          <i class="fa fa-file-pdf"></i>
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div className="TableBox mt-2">
                                    <Table striped bordered hover>
                                      <thead>
                                        <tr>
                                          <th>Group Code</th>
                                          <th>Planned(Pkgs)</th>
                                          <th>Planned(Kgs)</th>
                                          <th>Average Price</th>
                                          <th>Planned Amount(Rs)</th>
                                          <th>Balance Qty(Pkgs)</th>
                                          <th>Balance Qty(Kgs)</th>
                                          <th>Balance Amount(Rs)</th>
                                          <th>Knockdown(Pkgs)</th>
                                          <th>Knockdown(Kgs)</th>
                                          <th>Knockdown(Avg)</th>
                                          <th>Knockdown Amount(Rs)</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {getMyPlannerDataResponse != null ? (
                                          <>
                                            {getMyPlannerDataResponse &&
                                              getMyPlannerDataResponse.map(
                                                (plannerData) => (
                                                  <tr>
                                                    <td
                                                      className={
                                                        plannerData.plannedKgs >=
                                                          plannerData.purchaseIndicator
                                                          ? "myplanner_highlight_cell"
                                                          : ""
                                                      }
                                                    >
                                                      {plannerData.groupCode}
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.plannedPackages
                                                      }
                                                    </td>
                                                    <td>
                                                      {plannerData.plannedKgs}
                                                    </td>
                                                    <td>
                                                      {plannerData.averagePrice}
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.plannedAmount
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.balancePackages
                                                      }
                                                    </td>
                                                    <td>
                                                      {plannerData.balanceKgs}
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.balanceAmount
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.knockDownPackages
                                                      }
                                                    </td>
                                                    <td>
                                                      {plannerData.knockDownKgs}
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.knockDownAverageprice
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        plannerData.knockDownAmount
                                                      }
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </>
                                        ) : (
                                          "No data available"
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ) : 4 == activeTab ? (
                    <>
                      {userRoleCode == "BUYER" ||
                        userRoleCode == "ASSOCIATEBUYER" ||
                        userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
                        userRoleCode == "AUCTIONEER" ||
                        userRoleCode == "ASSOCIATEAUCTIONEER" ||
                        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ? (
                        <div
                          className={`TableBox ${4 == activeTab ? "" : "active"
                            }`}
                        >
                          {auctionDataColumnDetails?.length > 0 &&
                            auctionDataLiveBidDetails?.length > 0 ? (
                            <AuctionTable
                              // auctionDataColumnDetails={
                              //   getMyCatalogDataResponse?.columnDetails
                              // }
                              // auctionDataLiveBidDetails={
                              //   getMyCatalogDataResponse?.liveBidDetails
                              // }
                              auctionDataColumnDetails={
                                auctionDataColumnDetails
                              }
                              auctionDataLiveBidDetails={
                                auctionDataLiveBidDetails
                              }
                              handleChange={handleChange}
                              handleButton={handleButton}
                              isHoldAuctionCalled={isHoldAuctionCalled}
                              isTimeAvailable={
                                fetchAuctionCenterHeaderDataResponse &&
                                fetchAuctionCenterHeaderDataResponse.isTimeAvailable
                              }
                              activeTab={activeTab}
                              handleSelectRow={handleSelectRow}
                              selectedDataForMyCatalog={
                                selectedDataForMyCatalog
                              }
                              fetchAuctionCenterDataApiCallResponse={
                                fetchAuctionCenterDataApiCallResponse
                              }
                              countForShowMethod={countForShowMethod}
                              countForShow={countForShow}
                              userCurrentStatus={userCurrentStatus}
                              auctionUserId={auctionUserId}
                              auctionDetailId={auctionDetailId}
                            />
                          ) : (
                            <div className="NoData">No records found</div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : 5 == activeTab || 6 == activeTab ? (
                    <div
                      className={`TableBox ${5 == activeTab || 6 == activeTab ? "" : "active"
                        }`}
                    >
                      {allAuctionDataColumnDetails?.length > 0 &&
                        allAuctionDataLiveBidDetails?.length > 0 ? (
                        <>
                          <AuctionTable
                            auctionDataColumnDetails={
                              allAuctionDataColumnDetails
                            }
                            auctionDataLiveBidDetails={
                              allAuctionDataLiveBidDetails
                            }
                            handleChange={handleChange}
                            handleButton={handleButton}
                            isHoldAuctionCalled={isHoldAuctionCalled}
                            isTimeAvailable={
                              fetchAuctionCenterHeaderDataResponse &&
                              fetchAuctionCenterHeaderDataResponse.isTimeAvailable
                            }
                            activeTab={activeTab}
                            handleSelectRow={handleSelectRow}
                            selectedDataForMyCatalog={selectedDataForMyCatalog}
                            fetchAuctionCenterDataApiCallResponse={
                              fetchAuctionCenterDataApiCallResponse
                            }
                            countForShowMethod={countForShowMethod}
                            countForShow={countForShow}
                            userCurrentStatus={userCurrentStatus}
                            auctionUserId={auctionUserId}
                            auctionDetailId={auctionDetailId}
                          />
                        </>
                      ) : (
                        <div className="NoData">No data found</div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}

              {backendNotification ? (
                <div className="container-fluid p-0">
                  <div className="col-12  p-0">
                    <div id="notification">{backendNotification}</div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div class="status-bx-view Bharat">
                <div class="status-bx">
                  <span class="status-color-bx active-lots-color"></span>
                  <span class="status-name"> Active Lots</span>
                </div>

                <div class="status-bx">
                  <span class="status-color-bx pending-lots-color"></span>
                  <span class="status-name"> Pending Lots</span>
                </div>

                <div class="status-bx">
                  <span class="status-color-bx sold-lots-color"></span>
                  <span class="status-name"> Sold Lots</span>
                </div>

                <div class="status-bx">
                  <span class="status-color-bx unsold-lots-color"></span>
                  <span class="status-name"> Unsold Lots </span>
                </div>

                {userRoleCode == "BUYER" ||
                  userRoleCode == "ASSOCIATEBUYER" ||
                  userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                  <>
                    <div class="status-bx">
                      <span class="status-color-bx max-bid-reached-lots-color"></span>
                      <span class="status-name"> MaxBidOut </span>
                    </div>

                    <div class="status-bx">
                      <span class="status-color-bx winner-buyer-lots-color"></span>
                      <span class="status-name"> WinnerBuyer </span>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          {activeNotifications.length > 0 && (
            <div className="auction-marquee">
              <div
                className="notification"
                data-text={activeNotifications.map(note => note.notificationText).join(' | ')}
              >
                {activeNotifications.map((note, index) => (
                  <span key={index}>
                    {note.notificationText}
                    {index < activeNotifications.length - 1 && ' | '}
                  </span>
                ))}
              </div>
            </div>
          )}


          {isShownBidBook ? (
            <Modals
              title={"View Bid Book"}
              show={isShownBidBook}
              handleClose={() => handleButton("viewBidBook", false)}
              size="xl"
            >
              <ViewBidBookModal fromLiveAuction={true} />
            </Modals>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default Auction;
